interface ITermsSection {
  cancellationTableData: any[];
  cancellationTerms: any[];
  rescheduleTableData: any[];
  rescheduleTerms: any[];
}

const TermsSection: React.FC<ITermsSection> = (props) => {
  const { cancellationTableData, cancellationTerms, rescheduleTableData, rescheduleTerms } = props;

  return (
    <div className="flex flex-col gap-7 w-full terms-section-wrapper" style={{ padding: "17px 33px" }}>
      <p
        style={{
          fontSize: "18px",
          fontWeight: "700",
          color: "#7a7a7a",
          marginTop: "10px",
          textAlign: "center",
          textDecoration: "underline",
          textUnderlineOffset: "4px",
        }}
      >
        CANCELLATION & RESCHEDULE POLICIES
      </p>
      <div className="flex gap-4 section-wrapper">
        <div className="flex flex-col gap-4 w-2/5 border rounded border-slate-400 p-3">
          <div className="flex flex-col">
            <p
              className="text-center h-[40px]"
              style={{
                fontSize: "16px",
                fontWeight: "400",
                color: "#7a7a7a",
                textAlign: "center",
                textDecoration: "underline",
                textUnderlineOffset: "4px",
              }}
            >
              Cancellation Policy
            </p>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Days to Departure</th>
                  <th scope="col">Cancellation Fee</th>
                </tr>
              </thead>
              <tbody>
                {(cancellationTableData || [])?.map((data: any, index: number) => (
                  <tr key={index}>
                    <td>{data?.title}</td>
                    <td>{data?.fee_description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="">
              <ul>{(cancellationTerms || [])?.map((term: string, index: number) => <li key={index}>{term}</li>)}</ul>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4 w-3/5 border rounded border-slate-400 p-3">
          <div className="flex flex-col">
            <p
              className="h-[40px]"
              style={{
                fontSize: "16px",
                fontWeight: "400",
                color: "#7a7a7a",
                textAlign: "center",
                textDecoration: "underline",
                textUnderlineOffset: "4px",
              }}
            >
              Reschedule Policy
            </p>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Days to Departure</th>
                  <th scope="col">Cancellation Fee</th>
                </tr>
              </thead>
              <tbody>
                {(rescheduleTableData || [])?.map((data: any, index: number) => (
                  <tr key={index}>
                    <td>{data?.title}</td>
                    <td>{data?.fee_description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="">
            <ul>{(rescheduleTerms || [])?.map((term: string, index: number) => <li key={index}>{term}</li>)}</ul>
          </div>
        </div>
      </div>
      <div className="border rounded border-slate-400 p-3">
        <p
          className="text-center h-[40px]"
          style={{
            fontSize: "16px",
            fontWeight: "400",
            color: "#7a7a7a",
            textAlign: "center",
            textDecoration: "underline",
            textUnderlineOffset: "4px",
          }}
        >
          Split Payment Policy
        </p>
        <ul>
          <li>The balance payment must be made within 48 hours of the first payment.</li>
          <li>
            If full payment is not received within the stipulated 48 hours, the booking will be cancelled, and all paid
            amounts will be forfeited.
          </li>
          <li>
            If the booking is cancelled due to non-payment, the guest is allowed to reinstate the booking as per the
            reinstatement policy.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TermsSection;
